import { useSnackbar } from 'vuetify-use-dialog'

function fallbackCopyTextToClipboard(text): boolean {
  const textArea = document.createElement('textarea')
  textArea.value = text
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  let successful = true
  try {
    successful = document.execCommand('copy')
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err)
    successful = false
  }

  document.body.removeChild(textArea)
  return successful
}

declare let navigator: any

/**
 * Copies text to clipboard. Returns true if successful, false otherwise
 * @param text Text to copy
 */
export function useCopy() {
  const createSnackbar = useSnackbar()

  const copyTextToClipboard = async (
    text: string,
    snackbarText?: string
  ): Promise<boolean> => {
    if (!snackbarText) {
      snackbarText = 'Text wurde kopiert'
    }
    if (!navigator.clipboard) {
      const success = fallbackCopyTextToClipboard(text)
      if (success) {
        createSnackbar({
          text: snackbarText,
          snackbarProps: { color: 'green-darken-3' },
        })
      }
      return Promise.resolve(success)
    }

    try {
      await navigator.clipboard.writeText(text)
      createSnackbar({
        text: snackbarText,
        snackbarProps: { color: 'green-darken-3' },
      })
      return true
    } catch (err) {
      console.error('Async: Could not copy text: ', err)
      return false
    }
  }

  return {
    copyTextToClipboard,
  }
}
